import _ from 'lodash';
import template from './template.html';

class EditController {
  onChange() {
    this.smsTemplate = this.smsTypes[this.multilangLocale].filter((type) => this.smsType === type.smsTypeId);

    this.onUpdate({
      smsEnabled: this.smsEnabled,
      smsType: this.smsType,
      smsTemplate: _.get(this.smsTemplate, '[0].smsTemplateId'),
    });
  }

  isChecked(smsType, index) {
    return smsType === this.smsType ? true : index === 0;
  }
}

export default class EditComponent {
  constructor() {
    this.controller = EditController;
    this.template = template;
    this.bindings = {
      multilangLocale: '<',
      smsTypes: '<',
      smsEnabled: '<',
      smsType: '<',
      model: '<',
      availableLanguages: '<',
      onUpdate: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/sms/components/manage-login-sms-notification/components/manage-login-sms-notification-edit/component.js